const omnihubElem = document.getElementById("omni-hub-stock");

if (omnihubElem) {
  const intervalId = setInterval(() => {
    const elements = omnihubElem.getElementsByTagName("th");

    if (elements.length > 0) {
      for (const e of elements) {
        e.innerHTML = e.innerHTML.replace(/^NAILS INC NAGOYA/, "");
        e.innerHTML = e.innerHTML.replace(/^NAILS INC/, "");
      }
      // ポーリングを停止
      clearInterval(intervalId);
    }
  }, 500);  // 500msごとにチェック

} else {
  console.warn("Element with ID 'omni-hub-stock' not found.");
}

